module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-languages-icon-f9709bb93b9cec62b44b937abae9870f.svg";